import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	itemGroup: {
		...theme.typography.link1,
	},
}));
